import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import "../../Dashboard.less"
import { withRouter } from "../../../../lib/withRouter"
import { formatDate, getViewPatientData, postResource } from "../../../../lib"
import moment from "moment"
import RangePicker from "../../../ClaimReview/RangePicker"
import { ArrowDownUp } from "lucide-react"

export class ReferralDetail extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func,
        selectedReferral: PropTypes.object,
        onClose: PropTypes.func,
    };

    constructor(props) {
        super(props);
        const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
        const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

        this.state = {
            oldReferralList: [],
            loading: false,
            error: null,
            historyLoading: false,
            statusSteps: []
        };
    }

    componentDidMount() {
        console.log("Selected Referral for Detail View", this.props.selectedReferral);
        this.loadOldReferralHistory();
    }

    loadOldReferralHistory = async () => {
        this.setState({ historyLoading: true, oldReferralList: [] });
        const STATUS_ORDER = [
            "Accepted",
            "Declined",
            "Pending",
            "Outreach Initiated",
            "Referral Loop Closed"
        ];

        const history = await this.fetchOldReferralData(
            this.props.selectedReferral.memberId
        );

        let statusSteps = history
            .filter(item => item?.referralId == this.props.selectedReferral.referralId)
            .map(item => item?.historyStatus);

        // ✅ remove duplicates (optional but usually needed)
        statusSteps = [...new Set(statusSteps)];

        // ✅ custom order sort
        statusSteps.sort(
            (a, b) => STATUS_ORDER.indexOf(a) - STATUS_ORDER.indexOf(b)
        );
        console.log("statusSteps", statusSteps)

        this.setState({
            oldReferralList: history,
            historyLoading: false,
            statusSteps: statusSteps
        });
    };

    fetchOldReferralData = async (memberId) => {
        try {

            let apiUrl = `${this.props.settings.server.baseUrl}/referral/${memberId}/history`;

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            console.log("Old Referral Data", data)
            return data?.history ?? [];
        } catch (error) {
            console.error("Dashboard fetch failed:", error);
        }
    };

    // Define the referral status flow
    // getStatusSteps = () => {
    //     // You can customize this array based on your actual workflow
    //     return [
    //         'Accepted',
    //         'Declined',
    //         'Pending',
    //         'Outreach Initiated',
    //         'Referral Loop Closed'
    //     ];
    // };

    // Get the current step index based on the current status
    getCurrentStepIndex = (currentStatus) => {
        const steps = this.state.statusSteps || [];
        const index = steps.findIndex(step =>
            step.toLowerCase() === currentStatus?.toLowerCase()
        );
        return index >= 0 ? index : 0;
    };

    renderStatusTracker = () => {
        const { selectedReferral } = this.props;
        const steps = this.state.statusSteps || [];
        const currentStepIndex = this.getCurrentStepIndex(selectedReferral.currentStatus);
        const STATUS_COLORS = {
            Accepted: "#28A745",
            Declined: "#DC3545",
            Pending: "#FFC107",
            "Outreach Initiated": "#0D6EFD",
            "Referral Loop Closed": "#6C757D"
        };

        return (
            <div className="panel panel-default" style={{ marginBottom: '10px' }}>
                <div className="panel-heading" style={{ padding: '8px 15px' }}>
                    <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                        <i className="fa fa-tasks"></i> Referral Progress
                    </h5>
                </div>
                <div className="panel-body" style={{ padding: '20px 15px' }}>
                    <div className="referral-tracker">
                        <ul className="list-inline text-center" style={{ marginBottom: 0 }}>
                            {steps.map((step, index) => {
                                const isCompleted = index < currentStepIndex;
                                const isCurrent = index === currentStepIndex;
                                const isUpcoming = index > currentStepIndex;

                                return (
                                    <li key={index} style={{
                                        position: 'relative',
                                        width: `${100 / steps.length}%`,
                                        display: 'inline-block',
                                        verticalAlign: 'top',
                                        textAlign: 'center',
                                        padding: '0 5px'
                                    }}>
                                        {/* Connector Line */}
                                        {index < steps.length - 1 && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '15px',
                                                left: '50%',
                                                width: '100%',
                                                height: '2px',
                                                backgroundColor: isCompleted ? '#9ea0a2' : '#ddd',
                                                zIndex: 0
                                            }}></div>
                                        )}

                                        {/* Step Circle */}
                                        <div style={{
                                            position: 'relative',
                                            zIndex: 1,
                                            marginBottom: '8px'
                                        }}>
                                            <div style={{
                                                width: '30px',
                                                height: '30px',
                                                borderRadius: '50%',
                                                // backgroundColor: isCompleted ? '#5cb85c' : isCurrent ? '#5bc0de' : '#ddd',
                                                // border: isCurrent ? '3px solid #46b8da' : '2px solid ' + (isCompleted ? '#4cae4c' : '#ccc'),
                                                backgroundColor: STATUS_COLORS[step],
                                                border: `3px solid ${STATUS_COLORS[step]}`,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                boxShadow: isCurrent ? '0 0 0 3px rgba(91, 192, 222, 0.3)' : 'none',
                                                transition: 'all 0.3s ease'
                                            }}>
                                                {isCompleted ? (
                                                    <i className="fa fa-check"></i>
                                                ) : (
                                                    <span>{index + 1}</span>
                                                )}
                                            </div>
                                        </div>

                                        {/* Step Label */}
                                        <div style={{
                                            fontSize: '11px',
                                            fontWeight: isCurrent ? 'bold' : 'normal',
                                            color: (isCompleted || isCurrent) ? '#333' : '#999',
                                            wordWrap: 'break-word'
                                        }}>
                                            {step}
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    };

    renderDetailView() {
        const { oldReferralList, historyLoading } = this.state;
        const { selectedReferral, onClose } = this.props;
        if (!selectedReferral) return null;
        console.log("Old Referral List", oldReferralList);
        return (
            <>
                <div className="patient-sidebar-overlay" onClick={onClose}>
                    <div className="patient-sidebar clr-sidebar" onClick={e => e.stopPropagation()}>

                        {/* Header */}
                        <div className="sidebar-header">
                            <h4>Referral Details - #{selectedReferral.referralId}</h4>
                            <button className="close-btn" onClick={onClose}>
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div style={{ padding: "15px" }}>

                            {/* ================= Status Overview - Compact ================= */}
                            <div className="panel panel-primary" style={{ marginBottom: '10px' }}>
                                <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                    <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                        <i className="fa fa-info-circle"></i> Status Overview
                                    </h5>
                                </div>
                                <div className="panel-body" style={{ padding: '10px 15px' }}>
                                    <div className="row">
                                        <div className="col-xs-3">
                                            <small className="text-muted">Status</small>
                                            <div><span className="label label-info">{selectedReferral.currentStatus}</span></div>
                                        </div>
                                        <div className="col-xs-3">
                                            <small className="text-muted">Loop</small>
                                            <div>
                                                <span className={`label label-${selectedReferral.loopStatus === "Closed" ? "success" : "warning"}`}>
                                                    {selectedReferral.loopStatus}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-xs-3">
                                            <small className="text-muted">Updated</small>
                                            <div style={{ fontSize: '12px' }}>{formatDate(selectedReferral.lastUpdate)}</div>
                                        </div>
                                        <div className="col-xs-3">
                                            <small className="text-muted">Closure Reason</small>
                                            <div style={{ fontSize: '12px' }}>{selectedReferral?.loopClosureReason || 'N/A'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ================= Status Tracker ================= */}
                            {this.renderStatusTracker()}

                            <div className="row">
                                <div className="col-lg-6">
                                    {/* ================= Member & Referral Info - Compact ================= */}
                                    <div className="panel panel-default" style={{ marginBottom: '10px' }}>
                                        <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                            <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                                <i className="fa fa-user"></i> Member & Referral Information
                                            </h5>
                                        </div>
                                        <div className="panel-body" style={{ padding: '10px 15px' }}>
                                            <div className="row">
                                                <div className="col-xs-6">
                                                    <small className="text-muted">Member Name</small>
                                                    <div style={{ fontSize: '13px', marginBottom: '8px' }}><strong>{selectedReferral.clientName}</strong></div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <small className="text-muted">Service Type</small>
                                                    <div style={{ fontSize: '13px', marginBottom: '8px' }}>{selectedReferral.serviceType}</div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <small className="text-muted">Referral Type</small>
                                                    <div style={{ fontSize: '13px', marginBottom: '8px' }}>{selectedReferral.referralType}</div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <small className="text-muted">SLA / Due Date</small>
                                                    <div style={{ fontSize: '13px' }}>
                                                        <span className="text-danger">
                                                            <i className="fa fa-calendar"></i> {formatDate(selectedReferral.slaDate)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    {/* ================= Organizations & Provider - Compact ================= */}
                                    <div className="panel panel-default" style={{ marginBottom: '10px' }}>
                                        <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                            <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                                <i className="fa fa-building"></i> Organizations & Provider
                                            </h5>
                                        </div>
                                        <div className="panel-body" style={{ padding: '10px 15px' }}>
                                            <div className="row">
                                                <div className="col-xs-6">
                                                    <small className="text-muted">Referring Organization</small>
                                                    <div style={{ fontSize: '13px', marginBottom: '8px' }}>{selectedReferral.referringOrg}</div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <small className="text-muted">Receiving Organization</small>
                                                    <div style={{ fontSize: '13px', marginBottom: '8px' }}>{selectedReferral.receivingOrg}</div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <small className="text-muted">Receiving Provider</small>
                                                    <div style={{ fontSize: '13px' }}>{selectedReferral.receivingProvider}</div>
                                                </div>
                                                <div className="col-xs-6">
                                                    <small className="text-muted">Provider Phone</small>
                                                    <div style={{ fontSize: '13px' }}><i className="fa fa-phone"></i> {selectedReferral.receivingPhone}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* ================= Authorization Details - Compact ================= */}
                            <div className="panel panel-default" style={{ marginBottom: '10px' }}>
                                <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                    <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                        <i className="fa fa-check-circle"></i> Authorization Details
                                    </h5>
                                </div>
                                <div className="panel-body" style={{ padding: '10px 15px' }}>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-3">
                                            <small className="text-muted">Auth Status</small>
                                            <div style={{ fontSize: '12px', marginBottom: '8px' }}>
                                                <strong>{selectedReferral.authorizationStatus}</strong>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-sm-3">
                                            <small className="text-muted">Requested</small>
                                            <div style={{ fontSize: '12px', marginBottom: '8px' }}>
                                                {formatDate(selectedReferral.authorizationRequestedDate)}
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-sm-3">
                                            <small className="text-muted">Decision</small>
                                            <div style={{ fontSize: '12px', marginBottom: '8px' }}>
                                                {formatDate(selectedReferral.authorizationDecisionDate)}
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-sm-3">
                                            <small className="text-muted">End Date</small>
                                            <div style={{ fontSize: '12px' }}>
                                                {formatDate(selectedReferral?.slaDate)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ================= Referral History - Compact ================= */}
                            <div className="panel panel-default" style={{ marginBottom: '10px' }}>
                                <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                    <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                        <i className="fa fa-history"></i> Referral History
                                    </h5>
                                </div>
                                <div className="panel-body" style={{ padding: '10px 15px' }}>
                                    <div className="clr-table-wrap">
                                        <table className="clr-table" style={{ marginBottom: 0 }}>
                                            <thead>
                                                <tr>
                                                    {/* <th>ID</th> */}
                                                    <th>Referring Org</th>
                                                    <th>Receiving Org</th>
                                                    <th>Service</th>
                                                    <th>Status</th>
                                                    <th>SLA Date</th>
                                                    <th>Updated</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historyLoading && (
                                                    <tr>
                                                        <td colSpan="7" className="clr-table-empty">
                                                            <i className="fa fa-spinner fa-spin"></i> Loading...
                                                        </td>
                                                    </tr>
                                                )}

                                                {!historyLoading && oldReferralList.length === 0 && (
                                                    <tr>
                                                        <td colSpan="7" className="clr-table-empty">
                                                            No referral history found
                                                        </td>
                                                    </tr>
                                                )}

                                                {!historyLoading &&
                                                    oldReferralList
                                                        .filter((ref) => {
                                                            return !(
                                                                ref.referralId === this.props.selectedReferral.referralId &&
                                                                ref.historyStatus === this.props.selectedReferral.currentStatus
                                                            );
                                                        })
                                                        .map((ref, idx) => (
                                                            <tr key={idx}>
                                                                <td>{ref.referringOrg}</td>
                                                                <td>{ref.receivingOrg}</td>
                                                                <td>{ref.serviceType}</td>

                                                                <td>
                                                                    <span
                                                                        className="label label-default"
                                                                        style={{ fontSize: "11px" }}
                                                                    >
                                                                        {ref.historyStatus}
                                                                    </span>
                                                                </td>

                                                                <td>{formatDate(ref.slaDate)}</td>
                                                                <td>{formatDate(ref.lastUpdate)}</td>
                                                            </tr>
                                                        ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }

    render() {
        return (
            <>
                {this.renderDetailView()}
            </>
        );
    }
}

export default connect(state => state)(withRouter(ReferralDetail));
